import { Component, OnInit, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { InputComponent } from '../input/input.component';
import { NumberQualifierService } from 'src/app/model/api-services/qualifiers/number-qualifier.service';
import { AttributeInfo } from 'src/app/types/@types/sl-v-types';
import { SLLayer } from 'src/app/model/sl-layer';
import { GeoLocationQualifierService } from 'src/app/model/api-services/qualifiers/geo-location-qualifier-service';
import { SLMap } from 'src/app/model/sl-map';

@Component({
  selector: 'app-number-geoloc-part',
  templateUrl: './number-geoloc-part.component.html',
  styleUrls: ['./number-geoloc-part.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GeolocPartComponent extends InputComponent implements OnInit {

  public valueString = '';
  public suffix = '';
  public description = ''
  constructor(private domNode: ElementRef, protected cdr: ChangeDetectorRef) {
    super(cdr);
    this._domNode = this.domNode;
  }

  set currentValue(val: any) {
    switch (this.attribute.casting.entry.geoLocPart) {
      case null:
        this.valueString = '';
        break;
      case 'lattitude':
      case 'longitude':
        this.valueString = '' + GeoLocationQualifierService.ToDegreeString(val);
        break;
      case 'accuracy':
      case 'altitude':
        if ((this.attribute.type === 'integer') || (this.attribute.type === 'int')) {
          this.valueString = Math.floor(Number(val)) + ' meters';
        } else {
          if (isNaN(Number(val))) {
            this.currentValue = 0;
            return;
          } else {
            this.valueString = Number(val).toFixed(2) + ' meters';
          }
        }

        break;
      default:
        this.valueString = '' + (val === null) ? '' : val;
    }
    this.cdr.markForCheck();
    this.cdr.detectChanges();

  }
  get currentValue(): any {
    return super.GetSuperValue();
  }

  SetAttribute(layer: SLLayer, attribute: AttributeInfo) {
    super.SetAttribute(layer, attribute);
    if (attribute.casting && attribute.casting.entry && attribute.casting.entry.geoLocPart) {
      if (attribute.description === '') {
        this.description = 'Add a point to the map by clickng or using GPS editing buttons to collect a value for this field'
      }
    }
  }
}
